import { ActionEnum } from '../../../actions/types/orderActions.types';

export enum OrderPaymentModalView {
  PAYMENT = 'PAYMENT',
  SHARE_LINK = 'SHARE_LINK',
  CANCEL_LINK_CONFIRMATION = 'CANCEL_LINK_CONFIRMATION',
}

export const orderPaymentModalViewMapper: Record<
  ActionEnum.OPEN_CANCEL_PAYMENT_LINK_MODAL | ActionEnum.OPEN_ORDER_PAYMENT_MODAL,
  OrderPaymentModalView
> = {
  [ActionEnum.OPEN_CANCEL_PAYMENT_LINK_MODAL]: OrderPaymentModalView.CANCEL_LINK_CONFIRMATION,
  [ActionEnum.OPEN_ORDER_PAYMENT_MODAL]: OrderPaymentModalView.PAYMENT,
};
